import React, { memo } from 'react';
import { func, node, string, oneOf, bool } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './Button.module.scss';

const cx = classNames.bind(styles);

const Button = ({
  children,
  className,
  onClick,
  type,
  tag: Tag,
  href,
  color,
  download,
  isAutoWidth,
  ...attributes
}) => (
  <Tag
    className={cx('btn', className, type, color, { isAutoWidth: isAutoWidth })}
    href={href}
    onClick={onClick}
    download={download}
    {...attributes}
  >
    {children}
  </Tag>
);

Button.propTypes = {
  children: node.isRequired,
  className: string,
  onClick: func,
  type: oneOf(['pdf', 'print']),
  tag: oneOf(['a', 'button']),
  color: oneOf(['green', 'gray', 'bismark']),
  href: string,
  download: bool,
  isAutoWidth: bool,
};

Button.defaultProps = {
  onClick: null,
  className: null,
  tag: 'button',
  color: 'green',
  type: null,
  href: null,
  isAutoWidth: false,
  download: null,
};

export default memo(Button);



// WEBPACK FOOTER //
// ./src/components/Button/Button.js